module.exports = __webpack_public_path__ + "static/media/viewStatus.d70493bc.svg";